<script lang="ts" setup>
	import type { UploadTypeResponse } from '@/components/Shared/upload-input.vue'

	withDefaults(
		defineProps<{
			note?: string
			noTag?: boolean
		}>(),
		{
			note: 'Upload your corrected XLS/ CSV sheet to proceed with your current transaction'
		}
	)
	defineEmits<{
		(arg: 'init', param: UploadTypeResponse): void
	}>()
	const attr = useAttrs()
</script>

<template>
	<div class="mx-auto flex max-w-[564px] flex-col items-center">
		<shared-highlight-note v-if="!noTag" :note="note" class="border-warning-500 bg-warning-50" />
		<shared-upload-input v-bind="attr" class="w-full" placeholder="" @change="item => $emit('init', item)" />
	</div>
</template>
